/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acquisition_SpecsInputs */

const en_acquisition_specs = /** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisition Specs`)
};

const es_acquisition_specs = /** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificaciones de Adquisición`)
};

const fr_acquisition_specs = /** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécifications d'acquisition`)
};

const de_acquisition_specs = /** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akquisitionsspezifikationen`)
};

const id_acquisition_specs = /** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesifikasi Akuisisi`)
};

/** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */
const ja_acquisition_specs = en_acquisition_specs;

/** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */
const zh_acquisition_specs = en_acquisition_specs;

/** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */
const ar_acquisition_specs = en_acquisition_specs;

/** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */
const it_acquisition_specs = en_acquisition_specs;

/** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */
const ru_acquisition_specs = en_acquisition_specs;

/** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */
const pt_acquisition_specs = en_acquisition_specs;

/** @type {(inputs: Acquisition_SpecsInputs) => LocalizedString} */
const ko_acquisition_specs = en_acquisition_specs;

/**
* | output |
* | --- |
* | "Acquisition Specs" |
*
* @param {Acquisition_SpecsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acquisition_specs = /** @type {((inputs?: Acquisition_SpecsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acquisition_SpecsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acquisition_specs(inputs)
	if (locale === "es") return es_acquisition_specs(inputs)
	if (locale === "fr") return fr_acquisition_specs(inputs)
	if (locale === "de") return de_acquisition_specs(inputs)
	if (locale === "ja") return ja_acquisition_specs(inputs)
	if (locale === "zh") return zh_acquisition_specs(inputs)
	if (locale === "ar") return ar_acquisition_specs(inputs)
	if (locale === "id") return id_acquisition_specs(inputs)
	if (locale === "it") return it_acquisition_specs(inputs)
	if (locale === "ru") return ru_acquisition_specs(inputs)
	if (locale === "pt") return pt_acquisition_specs(inputs)
	return ko_acquisition_specs(inputs)
});